
<template>

<section class="campus-submission">
    
    <dam-submission :type="'campusSubmission'"></dam-submission>

</section>

</template>

<script>

import DamSubmission from './reusable/dam-submission/DAMSubmission.vue';

export default {
    data() {
        return {

        }
    },
    components: {
        DamSubmission
    },
    mounted() {

    },
    methods: {

    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// CampusSubmission.vue?ff9efb3e